<template>
    <span>
        <p>This is the test component named {{ name }}.</p>
    </span>
</template>

<script>
export default {
    name: 'testcomp',
    data() {
        return {
            name: 'Bob'
        }
    }
}
</script>